import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
} from "devextreme-react/data-grid";
import uiInfo from "../../../ui-info";
import PaginaToolbar from "../../../components/PaginaToolbar";
import { criarLancamentoIptuDs } from "../../../DataSources";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import Memoria from "../../../Memoria";
import notify from "devextreme/ui/notify";
import { getReport } from "../../../showReport";

const localStorageKey = "cadastroItbiGridState";

export default class LancamentoIptuBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this._formInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: {},
    };
    this.lancamentosIptuDs = criarLancamentoIptuDs().load();
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.imprimirListaErros = this.imprimirListaErros.bind(this);
    this.imprimirEspelho = this.imprimirEspelho.bind(this);
    this.cellRender = this.cellRender.bind(this);

    this.situacaoDs = [
      { id: 0, descricao: "PENDENTE" },
      { id: 1, descricao: "CANCELANDO" },
      { id: 2, descricao: "EXECUTANDO" },
      { id: 3, descricao: "FINALIZANDO" },
    ];

    this.tipoDs = [
      { id: 0, descricao: "INDEFINIDO" },
      { id: 1, descricao: "TODOS" },
      { id: 2, descricao: "POR INSCRIÇÃO" },
      { id: 3, descricao: "POR CARTOGRAFIA" },
      { id: 4, descricao: "POR DATA DE LANÇAMENTO" },
    ];
  }

  acompanharIptu(data) {
    this.props.history.push("acompanhar_iptu/" + data.id);
  }

  imprimirEspelho(data) {
    getReport(`report/espelho_lancamento_iptu/${data.prefeituraId}/${data.id}`);
  }

  imprimirListaErros(data) {
    getReport(`report/erros_lancamento_iptu/${data.prefeituraId}/${data.id}`);
  }
  imprimirComparativo(data) {
    getReport(`report/comparativo_iptu/${data.prefeituraId}/${data.id}`);
  }
  imprimirIsentos(data) {
    getReport(`report/isentos_imunes/${data.prefeituraId}/${data.id}`);
  }
  imprimirBemSucedidos(data) {
    getReport(`report/iptu_imoveis_ok/${data.prefeituraId}/${data.id}`);
  }

  filtrar(e) {
    let filtro = this.state.filtro;
    console.log(this.state.filtro);

    let filtroCorrente = [];

    if (filtro.ano !== null && filtro.ano !== undefined && filtro.ano !== "") {
      filtroCorrente.push(["exercicio", "=", filtro.ano]);
    }
    if (
      filtro.dataInicial !== null &&
      filtro.dataInicial !== undefined &&
      filtro.dataInicial !== ""
    ) {
      var dataInicial = new Date(filtro.dataInicial.setHours(0, 0, 0, 0));
      filtroCorrente.push(["data", ">=", dataInicial]);
    }
    if (
      filtro.dataFinal !== null &&
      filtro.dataFinal !== undefined &&
      filtro.dataFinal !== ""
    ) {
      var dataFinal = new Date(filtro.dataFinal.setHours(23, 59, 59, 999));
      filtroCorrente.push(["data", "<=", dataFinal]);
    }
    if (
      filtro.usuarioNome !== null &&
      filtro.usuarioNome !== undefined &&
      filtro.usuarioNome !== ""
    ) {
      filtroCorrente.push(["vendedor", "contains", filtro.usuarioNome]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro() {
    this.setState({ filtro: {} });
    this.filtrar();
    this._formInstance.instance.repaint();
  }

  onAtualizandoRow(e) {
    e.cancel = true;

    if (!e.data.id) {
      notify("Registro migrado, edição não permitida.", "error");
      return;
    }

    this.props.history.push("lancamentoiptu/editar/" + e.data.lancamentoSeq);
  }

  componentDidMount() {
    Memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={7}
              labelLocation={"top"}
              ref={(form) => (this._formInstance = form)}
            >
              <SimpleItem
                dataField="ano"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Ano" />
              </SimpleItem>
              <SimpleItem
                dataField="dataInicial"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
              >
                <Label text="Data Inicial" />
              </SimpleItem>
              <SimpleItem
                dataField="dataFinal"
                dataType="date"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
              >
                <Label text="Data Final" />
              </SimpleItem>
              <SimpleItem dataField="usuarioNome" colSpan={4}>
                <Label text="Nome do Usuário" />
              </SimpleItem>
            </Form>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <PaginaToolbar titulo="IPTU" novoCb={this.novoRegistro.bind(this)}>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarLancamentoIptuDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              onEditingStart={this.onAtualizandoRow}
              keyExpr={"id"}
            >
              <Editing
                allowDeleting={true}
                allowUpdating={true}
                useIcons={true}
              />

              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  {
                    hint: "Acompanhar",
                    icon: "search",
                    visible: !this.onSelecionado,
                    onClick: (e) => this.acompanharIptu(e.row.data),
                  },
                  {
                    hint: "Imprimir Espelho",
                    icon: "exportpdf",
                    visible: !this.onSelecionado,
                    onClick: (e) => this.imprimirEspelho(e.row.data),
                  },
                  {
                    hint: "Lista de Erros",
                    icon: "bulletlist",
                    visible: !this.onSelecionado,
                    onClick: (e) => this.imprimirListaErros(e.row.data),
                  },
                  {
                    hint: "Relatório Comparativo",
                    icon: "exportpdf",
                    visible: !this.onSelecionado,
                    onClick: (e) => this.imprimirComparativo(e.row.data),
                  },
                  {
                    hint: "Imóveis Isentos ou Imunes",
                    icon: "exportpdf",
                    visible: !this.onSelecionado,
                    onClick: (e) => this.imprimirIsentos(e.row.data),
                  },
                  {
                    hint: "Imóveis Bem-Sucedidos",
                    icon: "exportpdf",
                    visible: !this.onSelecionado,
                    onClick: (e) => this.imprimirBemSucedidos(e.row.data),
                  },
                  {
                    icon: "repeat",
                    visible: this.onSelecionado ? true : false,
                    onClick: this.onSelecionado,
                  },
                ]}
              />

              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"data"}
                dataType={"datetime"}
                caption={"Data"}
                format={"dd/MM/yyyy HH:mm"}
                width={150}
                sortIndex={1}
                sortOrder={"desc"}
              />

              <Column
                dataField={"exercicio"}
                caption={"Ano"}
                width={90}
              />


              <Column dataField={"sucessos"} caption={"Resumo"} width={90} />

              <Column
                dataField={"posicaoFiscal"}
                caption={"% Sucesso"}
                cellRender={this.cellRender}
                width={90}
              />

              <Column dataField={"tipo"} caption={"Tipo"} width={160}>
                <Lookup
                  dataSource={this.tipoDs}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>

              <Column dataField={"paramsLancamento"} caption={"Parâmetros"} />

              <Column dataField={"usuario.nome"} caption={"Usuário"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("lancamentoiptu/novo");
  }

  cellRender({ data }) {
    let success = data.sucessos;

    if (success) {
      success = success.split("/");
      let percentage = parseInt(success[0]) / parseInt(success[1]);
      percentage = percentage * 100;
      percentage = percentage.toFixed(2);
      percentage = parseFloat(percentage);
      return `${percentage}%`;
    }
  }
}
